import axios from '../../utils/axios';

/**
 * Create user via UPP-Service (for partner portal team flow).
 * Accepts role and designation.
 */
export const createUserUpp = async (data) => {
  const body = {
    full_name: data.full_name || data.name,
    email: data.email,
    phone: data.phone || data.contact?.phone,
    country_code: data.country_code || '+91',
    password: data.password || '123456789',
    role: data.role || 'agent',
    designation: data.designation || null,
  };
  const response = await axios.post(`/users`, body);
  return response.data;
};
